import React from "react";
import {KatCard} from "@amzn/katal-react";
import {useTranslation} from "react-i18next";
import {IEvent} from "src/context/models/Event";
import {EVENT_CARD_VARIANT, EVENT_TITLE} from "src/common/constants/constants";
import {UpdateEventButton} from "src/components/healthDashboard/editableView/UpdateEventButton";
import {isSpectrumHubSite} from "src/common/utils/dashboardUtils";
import {getFormattedUTCDateTime} from "src/common/utils/dateUtils";

export type EventCardProps = {
    event: IEvent;
};

export const EventCard: React.FC<EventCardProps> = ({
                                                        event
                                                    }) => {
    if (!event.lastUpdatedAt) {
        console.error("Every event retrieved should have lastUpdated date. Skipping event.");
        return null;
    }

    const {t} = useTranslation();

    return (
        <KatCard className="event-card"
                 title={EVENT_TITLE[event.eventSeverity as keyof typeof EVENT_TITLE]}
                 variant={EVENT_CARD_VARIANT[event.eventSeverity as keyof typeof EVENT_CARD_VARIANT] as KatCard.Variant}>
            <span slot="subtitle">
                <div className="event-card-title">
                    <p><b>{`${event.summary}`}</b></p>
                    <p>{` - ${getFormattedUTCDateTime(event.start)}`}</p>
                </div>
            </span>
            <div className="event-card-desc">
                <p>{`${event.description}`}</p>
                <p>
                    <i className="last-update">
                        {`${event.lastModifiedBy
                            ? `${t("Last updated by -")} ${event.lastModifiedBy + " : "}`
                            : `${t("Last update -")}`}
                        ${getFormattedUTCDateTime(event.lastUpdatedAt)}`}
                    </i>
                </p>
                {isSpectrumHubSite() ?
                    <UpdateEventButton event={event} section={event.section} operation={event.operation}/>
                    : null}
            </div>
        </KatCard>)
}